export default {
  resetPassword: 'Reset password',
  ready: 'The instructions where sent to your email address'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/forgot/en.js